import { render, staticRenderFns } from "./BaseOrder.vue?vue&type=template&id=b966cc76"
import script from "./BaseOrder.vue?vue&type=script&lang=js"
export * from "./BaseOrder.vue?vue&type=script&lang=js"
import style0 from "./BaseOrder.vue?vue&type=style&index=0&id=b966cc76&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports